import React from 'react'
import useSelector from 'hooks/use-selector'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import updateSelectedUseItWithVariantIdProductAction from 'modules/product/redux/actions/update-selected-perfect-your-look-variant-id'
import useDispatch from 'hooks/use-dispatch'

export default function QuickShopProductSidebarUseItWithProductSwatchPickerAutoSelect () {
  const dispatch = useDispatch()

  /**
   * @type {ProductVariantCollection}
   */
  const selectedVariant = useSelector(getSelectedVariantSelect)

  const handleUpdate = () => {
    if (!selectedVariant?.pyl_variant_id) {
      return
    }

    dispatch(
      updateSelectedUseItWithVariantIdProductAction(
        selectedVariant.pyl_variant_id
      )
    )
  }

  React.useEffect(() => {
    handleUpdate()
  }, [selectedVariant])

  return <></>
}
